var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyarewedoingit3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Why are we doing it") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Landing_page-1",
    transform: "translate(-611.000000, -912.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Why-are-we-doing-it",
    transform: "translate(611.000000, 912.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3,94 L101.706667,100.613333 L114.413333,79.1466667 L101.666667,71.7533333 C102.675767,66.9075591 102.723334,61.9107732 101.806667,57.0466667 L114.666667,49.7533333 L102.166667,28.1666667 L89.4066667,35.4 C85.6364161,32.1050409 81.2620884,29.573727 76.5266667,27.9466667 L76.5266667,13.3333333 L51.3866667,13.3333333 L51.3866667,27.9 C46.6986152,29.4895897 42.359877,31.9656354 38.6066667,35.1933333 L26.0666667,27.92 L13.3333333,49.3866667 L26,56.72 C25.0489472,61.5446894 25.0489472,66.5086439 26,71.3333333 L13.3333333,78.5333333 L25.8333333,100.12 L38.6666667,92.88 C42.4128113,96.0919873 46.739712,98.5564198 51.4133333,100.14 L51.4133333,114.666667 L76.5533333,114.666667 L76.5533333,100.093333 C81.6183887,99.3988666 86.3838929,97.2865141 90.3,94 Z",
    id: "622ed3f9-81c0-4219-8b01-bcbd8f596c75",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6266667,62.7866667 C83.1320252,70.5418083 78.7796275,77.7986847 71.7001621,81.0047381 C64.6206967,84.2107916 56.2955245,82.6951633 50.8001806,77.1998194 C45.3048367,71.7044755 43.7892084,63.3793033 46.9952619,56.2998379 C50.2013153,49.2203725 57.4581917,44.8679748 65.2133333,45.3733333 C74.5663746,45.9828179 82.0171821,53.4336254 82.6266667,62.7866667 L82.6266667,62.7866667 Z",
    id: "ec65c131-82ae-44a4-a87e-b620c5c291c4",
    stroke: "#F63F40",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyarewedoingit3X);
export default __webpack_public_path__ + "static/media/Why are we doing it@3x.ffa70d7e771d449e34462a963ce52d00.svg";
export { ForwardRef as ReactComponent };